import React, { useState } from "react";
import iib from "../assets/iib.png";
import csc from "../assets/csc.png";
import digIn from "../assets/Digital_India.png";
import Button from "./Button";
import { LandingPageNavProps } from "./ComponentProps";
import Dropdown from "./Dropdown";
import { AiFillFilePdf } from "react-icons/ai";
import { FaRegFilePdf } from "react-icons/fa6";
import Card from "./Card";
import img1 from "../assets/LandingImg1.png";
import img2 from "../assets/LandingImg2.png";
import certi from "../assets/certi.png";
import trainer from "../assets/trainer.png";
import map from "../assets/IndiaMap.png";
import { CiClock2 } from "react-icons/ci";
import cardImg from "../assets/cardImg.png";
import { RiPresentationLine } from "react-icons/ri";
import { LiaLanguageSolid } from "react-icons/lia";
import money from "../assets/money.png";
import hut from "../assets/hut.png";
import cert from "../assets/cert.png";
import bcc1 from "../assets/bcc1.png";
import IconButtonLink from "./IconButtonLink";
import bcc2 from "../assets/bcc2.png";
import footerImage from "../assets/footer.png";
import { useTranslation } from "react-i18next";
import photoSampleImg from "../assets/sample_imgs/photo.png";
import signatureSampleImg from "../assets/sample_imgs/signature.png";
import idCardSampleImg from "../assets/sample_imgs/id_card.png";
import degreeSampleImg from "../assets/sample_imgs/degree.png";

const options = [
  { label: "English", value: "en" },
  {
    label: (
      <>
        हिन्दी <br />
        (Hindi)
      </>
    ),
    value: "hi",
  },
  {
    label: (
      <>
        বাংলা <br />
        (Bengali)
      </>
    ),
    value: "bn",
  },
  {
    label: (
      <>
        मराठी <br />
        (Marathi)
      </>
    ),
    value: "mr",
  },
  {
    label: (
      <>
        తెలుగు <br />
        (Telugu)
      </>
    ),
    value: "te",
  },
  {
    label: (
      <>
        ગુજરાતી <br />
        (Gujarati)
      </>
    ),
    value: "gu",
  },
  {
    label: (
      <>
        ಕನ್ನಡ <br />
        (Kannada)
      </>
    ),
    value: "kn",
  },
  {
    label: (
      <>
        മലയാളം <br />
        (Malayalam)
      </>
    ),
    value: "ml",
  },
  {
    label: (
      <>
        தமிழ் <br />
        (Tamil)
      </>
    ),
    value: "ta",
  },
  {
    label: (
      <>
        ଓଡିଆ <br />
        (Odia)
      </>
    ),
    value: "or",
  },
  {
    label: (
      <>
        ਪੰਜਾਬੀ <br />
        (Punjabi)
      </>
    ),
    value: "pa",
  },
];

const LandingPageNav: React.FC<LandingPageNavProps> = ({
  links,
  onButtonClick,
}) => {
  const handleDownload = () => {
    const url =
      "https://iibf-uploads-prod.s3.ap-south-1.amazonaws.com/dra-prospectus-english.pdf";
    const link = document.createElement("a");
    link.href = url;
    link.download = "prospectus-dra-training.pdf";
    link.click();
  };

  const downloadDraHindiPdf = () => {
    const url =
      "https://iibf-uploads-prod.s3.ap-south-1.amazonaws.com/prospectus-dra-training-hindi.pdf";
    const link = document.createElement("a");
    link.href = url;
    link.download = "prospectus-dra-training-hindi.pdf";
    link.click();
  };

  const { t, i18n } = useTranslation();
  const [activeSampleImage, setActiveSampleImage] = useState<string | null>(
    null,
  );
  const [zoomLevel, setZoomLevel] = useState(1);

  const handleOptionSelect = (option: any) => {
    i18n.changeLanguage(option.value);
  };
  const handleScroll = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const closeSampleModal = () => {
    setActiveSampleImage(null);
    setZoomLevel(1);
  };
  return (
    <div>
      <div className="w-full bg-navBgLandingOrange py-2 px-6 flex items-center justify-end">
        <Dropdown
          icon={<AiFillFilePdf />}
          size="small"
          buttonText={t("Language")}
          options={options}
          onOptionSelect={handleOptionSelect}
          styles={null}
        />
      </div>

      <div className="w-full bg-white px-6 py-2 flex items-center justify-between shadow lg:flex-row sm:flex-col sm:items-center">
        <div className="flex items-center gap-4">
          <img src={digIn} alt="digital india" className="h-8" />
        </div>

        <h1 className="text-textBlue font-header text-2xl hidden lg:block">
          {t("CSC-IIBF Training Program")}
        </h1>

        <img src={csc} alt="csc" className="h-8" />
      </div>

      <div className="w-full bg-navBgLandingGreen px-6 py-2 flex justify-end md:justify-between items-center lg:flex-row sm:flex-col sm:items-center">
        <div className="hidden lg:flex space-x-6">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.href}
              onClick={() => handleScroll(link.href.substring(1))}
              className="text-white font-body font-semibold text-md hover:bg-green-800 hover:rounded-lg px-3 py-2"
            >
              {t(link.label)}
            </a>
          ))}
        </div>

        <Button
          type="OutlineSecondaryButton"
          size="medium"
          text={t("Candidate Login")}
          onClick={() => {
            window.open("https://candidate-iibf.cscacademy.org/", "_blank");
          }}
          styles={{
            color: "white",
            borderColor: "white",
            border: "2px solid white",
            font: "bold",
          }}
        />
      </div>
      <div
        id="our-programs"
        className="flex flex-col gap-4 bg-sky-100 pt-1 pb-14 text-center align-center"
      >
        <div className="bg-yellow-100 border border-yellow-400 text-yellow-900 px-6 py-4 rounded-md mx-[5px] text-[0.5rem] md:text-sm font-semibold leading-tight text-left">
          {i18n.language === 'en' || i18n.language === 'hi' ? (
            <span dangerouslySetInnerHTML={{ __html: t("Attention Notice") }} />
          ) : (
            <span className="whitespace-pre-wrap">
              {t("Attention Notice")}
              <a
                className="text-solidBlue ml-1"
                href="https://portal.iibf.org.in/bcbf/apply-exam"
                // href="https://iibf.esdsconnect.com/iibfbcbf/apply_exam_individual?ctype=Tk0="
              >
                (https://portal.iibf.org.in/bcbf/apply-exam)
                {/* (https://iibf.esdsconnect.com/iibfbcbf/apply_exam_individual?ctype=Tk0=) */}
              </a>
            </span>
          )}
        </div>
        <h1 className="font-semibold text-2xl">
          <span className="text-solidBlue">
            {t("Empowering Future Banking Professionals")}
          </span>{" "}
          - {t("Our Programs")}
        </h1>
        <div className="flex flex-col md:flex-row justify-center gap-4 pl-8 pr-8">
          <Card
            type="small"
            imageSrc={img1}
            headerText="DRA-For Graduates"
            pointers={[
              {
                text: "50 hours",
                icon: <CiClock2 />,
              },
              {
                text: "Live Online Classes + Digital Content",
                icon: <RiPresentationLine />,
              },
              {
                text: "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese",
                icon: <LiaLanguageSolid />,
              },
            ]}
            buttonText="Enroll Now for ₹5,000 + GST (18%)"
            onButtonClick={() => {
              window.open(
                "https://onboarding-dra.cscacademy.org/onboard-user-self?course=dra-graduate",
                "_blank",
              );
            }}
          />

          <Card
            type="small"
            imageSrc={img2}
            headerText="DRA-For Under Graduates"
            pointers={[
              {
                text: "100 hours",
                icon: <CiClock2 />,
              },
              {
                text: "Live Online Classes + Digital Content",
                icon: <RiPresentationLine />,
              },
              {
                text: "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese",
                icon: <LiaLanguageSolid />,
              },
            ]}
            buttonText="Enroll Now for ₹6,000 + GST (18%)"
            onButtonClick={() => {
              window.open(
                "https://onboarding-dra.cscacademy.org/onboard-user-self?course=dra-undergraduate",
                "_blank",
              );
            }}
          />
          <Card
            type="small"
            imageSrc={bcc1}
            headerText="BC Training - Basic Certification"
            pointers={[
              {
                text: "28 hours",
                icon: <CiClock2 />,
              },
              {
                text: "Live Online Classes + Digital Content",
                icon: <RiPresentationLine />,
              },
              {
                text: "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese",
                icon: <LiaLanguageSolid />,
              },
            ]}
            buttonText="Enroll Now for ₹1,800 + GST (18%)"
            onButtonClick={() => {
              window.open(
                "https://onboarding-bcbf.cscacademy.org/onboard-user-self?course=bcbf-basic",
                "_blank",
              );
            }}
          />
          <Card
            type="small"
            imageSrc={bcc2}
            headerText="BC Training - Advanced Certification"
            pointers={[
              {
                text: "42 hours",
                icon: <CiClock2 />,
              },
              {
                text: "Live Online Classes + Digital Content",
                icon: <RiPresentationLine />,
              },
              {
                text: "Languages: English, Hindi, Gujarati, Marathi, Malayalam, Kannada, Oriya, Bengali, Tail, Telugu, Assamese",
                icon: <LiaLanguageSolid />,
              },
            ]}
            buttonText="Enroll Now for ₹2700 + GST (18%)"
            onButtonClick={() => {
              window.open(
                "https://onboarding-bcbf.cscacademy.org/onboard-user-self?course=bcbf-advance",
                "_blank",
              );
            }}
          />
        </div>
      </div>

      <div className="mx-6 md:mx-20 mt-8 bg-blue-50 border-2 border-black rounded-lg p-4 mb-4 text-sm text-gray-700 text-left">
        <p className="font-bold text-blue-900 mb-1">
          Sample Image Quality (For Submitted Documents Purpose)
        </p>
        <p className="leading-relaxed mb-3">
          Review these sample images to ensure your uploaded documents are
          clear, fully visible, and meet submission standards. Your documents
          must be completely unblurred with no parts hidden or cut off. When
          uploading your photograph, ensure it is a real, current photo of your
          appearance; do not take a picture of an existing passport photo.
        </p>
        <div className="flex flex-wrap gap-x-4 gap-y-2 font-semibold">
          <button
            type="button"
            onClick={() => setActiveSampleImage("photo")}
            className="text-red-600 hover:underline text-xs flex items-center gap-1 focus:outline-none"
          >
            👁️ Photo Sample
          </button>
          <button
            type="button"
            onClick={() => setActiveSampleImage("signature")}
            className="text-red-600 hover:underline text-xs flex items-center gap-1 focus:outline-none"
          >
            👁️ Signature Sample
          </button>
          <button
            type="button"
            onClick={() => setActiveSampleImage("id_card")}
            className="text-red-600 hover:underline text-xs flex items-center gap-1 focus:outline-none"
          >
            👁️ ID Card Sample
          </button>
          <button
            type="button"
            onClick={() => setActiveSampleImage("degree")}
            className="text-red-600 hover:underline text-xs flex items-center gap-1 focus:outline-none"
          >
            👁️ Degree Sample
          </button>
        </div>
      </div>

      <div className="flex flex-col gap-2 text-center">
        <h2
          id="key-features"
          className="text-solidBlue font-semibold mt-10 mb-2 text-2xl"
        >
          {t("Key Features")}
        </h2>
        <div className="flex flex-col pl-6 pr-6 md:pl-20 md:pr-20 gap-4">
          <div className="flex flex-col md:flex-row gap-8 justify-center items-center">
            <div className="flex flex-col gap-4 p-8 bg-skyGrey rounded-md text-left">
              <img
                src={map}
                alt="india"
                style={{ width: "fit-content", height: "40px" }}
              />
              <h2 className="font-bold text-sm md:text-lg">
                {t("Training DRAs all over India")}
              </h2>
              <h3 className="text-sm">
                {t("Empowering DRAs with skills and")}
                <br />
                {t("knowledge in India")}
              </h3>
            </div>
            <div className="flex flex-col gap-4 p-8 bg-skyGrey rounded-md text-left">
              <img
                src={certi}
                alt="india"
                style={{ width: "fit-content", height: "40px" }}
              />
              <h2 className="font-bold text-sm md:text-lg">
                {t("CAIIB-Certified Trainers")}
              </h2>
              <h3 className="text-sm">
                {t("With over 20 years of rich experience in the")}
                <br />
                {t("banking sector, we bring trusted expertise.")}
              </h3>
            </div>
            <div className="flex flex-col gap-4 p-8 bg-skyGrey rounded-md text-left">
              <img
                src={trainer}
                alt="india"
                style={{ width: "fit-content", height: "40px" }}
              />
              <h2 className="font-bold text-sm md:text-lg">
                {t("Efficient Training Support")}
              </h2>
              <h3 className="text-sm">
                {t("Providing comprehensive and seamless support to")}
                <br />
                {t("ensure effective and impactful training experiences.")}
              </h3>
            </div>
          </div>
          <div className="w-full flex flex-col md:flex-row gap-8 rounded-md py-6 px-10">
            <img src={cardImg} alt="img" className="w-full md:w-1/2" />
            <div className="w-full md:w-1/2 flex flex-col text-left justify-center gap-2 ">
              <h2 id="about-us" className="text-solidBlue font-bold text-2xl">
                {t("About Us")}
              </h2>
              <h3 className="font-bold">{t("About CSC Academy")}</h3>
              <h3 className="text-sm text-justify">
                {t("CSC Academy Establishment")}
                <br />
                <br /> {t("CSC Academy Programs & Funding")}
              </h3>
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-between gap-4 py-4 px-10">
            <div className="flex flex-col items-center gap-4">
              <img src={money} alt="img" className="w-16 h-16" />
              <h3 className="font-bold text-center">
                {t("Advance Your Career with the DRA Certification Program")}
              </h3>
              <p className="text-center text-sm px-2 md:px-8 text-justify">
                {t("Advance Your Career Description")}
              </p>
            </div>
            <div className="flex flex-col items-center gap-4">
              <img src={hut} alt="img" className="w-16 h-16" />
              <h3 className="font-bold text-center">
                {t("Transform your business by becoming a certified BC/BF")}
              </h3>
              <p className="text-center text-sm px-2 md:px-8 text-justify">
                {t("Transform Your Business Description")}
              </p>
            </div>
          </div>
          {/* <div className="flex flex-col md:flex-row mt-8 px-10">
            <div className="flex flex-col text-left p-2 md:p-10 justify-center">
              <h2 className="text-solidBlue font-bold text-2xl md:text-2xl">
                {t("Training Completion Certificate")}
              </h2>
              <h3 className="text-justify">
                {t("Training Completion Description")}
              </h3>
            </div>
            <img src={cert}></img>
          </div> */}
        </div>
        <h2
          id="important-resources"
          className="text-solidBlue font-semibold mt-10 mb-2 text-sm md:text-2xl p-2 md:p-1"
        >
          {t("Download Important Resources")}
        </h2>
        <h3 className="font-bold p-2 md:p-1">
          {t("Download Important Resources Description")}
        </h3>
        <div className="flex flex-col gap-4 p-6">
          <div className="flex gap-2 flex-col md:flex-row justify-center">
            {/* <IconButtonLink
              icon={<FaRegFilePdf size="20px" className="text-red-500" />}
              size="large"
              text="How to Register?"
              onClick={onButtonClick}
              isDisabled={false}
              styles={null}
            />
            <IconButtonLink
              icon={<FaRegFilePdf size="20px" className="text-red-500" />}
              size="large"
              text="A Guide to DigiLocker"
              onClick={onButtonClick}
              isDisabled={false}
              styles={null}
            /> */}
            <IconButtonLink
              icon={<FaRegFilePdf size="20px" className="text-red-500" />}
              size="large"
              text="Prospectus - DRA Training (English)"
              onClick={handleDownload}
              isDisabled={false}
              styles={{
                width: "40%",
              }}
            />
            <IconButtonLink
              icon={<FaRegFilePdf size="20px" className="text-red-500" />}
              size="large"
              text="सूचीपत्र - डीआरए प्रशिक्षण (हिन्दी)"
              onClick={downloadDraHindiPdf}
              isDisabled={false}
              styles={{
                width: "40%",
              }}
            />
            {/* <IconButtonLink
              icon={<FaRegFilePdf size="20px" className="text-red-500" />}
              size="large"
              text="Prospectus - BC/BF Training (English)"
              onClick={onButtonClick}
              isDisabled={false}
              styles={null}
            />
          </div>
          <div className="flex gap-2 justify-center flex-col md:flex-row w-full md:w-1/2 ">
            <IconButtonLink
              icon={<FaRegFilePdf size="20px" className="text-red-500" />}
              size="large"
              text="सूचीपत्र - डीआरए प्रशिक्षण (हिन्दी)"
              onClick={onButtonClick}
              isDisabled={false}
              styles={null}
            />
            <IconButtonLink
              icon={<FaRegFilePdf size="20px" className="text-red-500" />}
              size="large"
              text="सूचीपत्र -  बीसी/बीएफ (हिन्दी)"
              onClick={onButtonClick}
              isDisabled={false}
              styles={null}
            /> */}
          </div>
        </div>
      </div>

      <div
        className="bg-cover bg-no-repeat py-10 mt-6 text-white w-full overflow-hidden"
        style={{ backgroundImage: `url(${footerImage})` }}
      >
        <div className="flex flex-col items-center mt-10 md:items-start gap-2 px-4 md:px-12 w-full md:ml-40 2xl:ml-80 xl:mt-16">
          <h2 className="text-lg md:text-2xl font-bold mb-2 text-center md:text-left mt-20">
            {t("CSC-IIBF Training Program")}
          </h2>

          <div className="flex flex-col md:flex-row justify-center  md:justify-start items-center gap-10 w-full">
            <div className="flex bg-white px-4 gap-56 py-4 rounded-md">
              <img src={digIn} alt="DigIn Logo" className="h-[30px]" />
              <img src={csc} alt="CSC Logo" className="h-[30px]" />
            </div>

            <div className="flex flex-col text-center md:text-left">
              <p className="text-sm md:text-base mb-1">
                {t("For Support, Contact Us")}
              </p>
              <p className="text-sm md:text-base mb-1">
                For DRA- cscdra@cscacademy.org <br />
                For BC- cscbc@cscacademy.org
              </p>
              <p className="text-base font-semibold">+91 70119 58630</p>
            </div>

            <Button
              type="SolidOrangeButton"
              size="medium"
              text="Candidate Login"
              onClick={() => {
                window.open("https://candidate-iibf.cscacademy.org/", "_blank");
              }}
            />
          </div>
        </div>
      </div>
      {activeSampleImage && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center p-4">
          <div className="bg-white p-6 rounded-lg max-w-[95vw] md:max-w-4xl w-full h-[90vh] max-h-[90vh] shadow-lg flex flex-col items-center">
            <div className="flex justify-between items-center w-full mb-4 flex-shrink-0">
              <h3 className="text-lg font-semibold text-gray-900 capitalize">
                {activeSampleImage === "id_card"
                  ? "ID Card"
                  : activeSampleImage}{" "}
                Sample
              </h3>
              <button
                type="button"
                onClick={closeSampleModal}
                className="text-gray-400 hover:text-gray-600 text-xl font-bold focus:outline-none"
              >
                &times;
              </button>
            </div>

            <div
              className={`border border-gray-200 rounded bg-gray-50 w-full flex-grow ${
                zoomLevel > 1
                  ? "overflow-auto flex justify-start items-start"
                  : "overflow-hidden flex justify-center items-center"
              }`}
            >
              <img
                src={
                  activeSampleImage === "photo"
                    ? photoSampleImg
                    : activeSampleImage === "signature"
                      ? signatureSampleImg
                      : activeSampleImage === "id_card"
                        ? idCardSampleImg
                        : degreeSampleImg
                }
                alt={`${activeSampleImage} Sample`}
                style={
                  zoomLevel > 1
                    ? {
                        width: `${zoomLevel * 100}%`,
                        maxWidth: "none",
                        height: "auto",
                      }
                    : undefined
                }
                className={
                  zoomLevel > 1 ? "" : "max-h-full max-w-full object-contain"
                }
              />
            </div>

            <div className="flex gap-2 w-full mt-4 flex-shrink-0 items-center">
              <button
                type="button"
                onClick={() => setZoomLevel((z) => Math.max(1, z - 0.1))}
                disabled={zoomLevel <= 1}
                className="border border-solidBlue text-solidBlue hover:bg-blue-50 disabled:opacity-40 disabled:cursor-not-allowed font-semibold py-2 px-4 rounded-lg transition duration-300 focus:outline-none"
              >
                − Zoom Out
              </button>

              <span className="text-sm font-semibold text-gray-600 min-w-[3.5rem] text-center">
                {Math.round(zoomLevel * 100)}%
              </span>

              <button
                type="button"
                onClick={() => setZoomLevel((z) => Math.min(3, z + 0.01))}
                disabled={zoomLevel >= 3}
                className="border border-solidBlue text-solidBlue hover:bg-blue-50 disabled:opacity-40 disabled:cursor-not-allowed font-semibold py-2 px-4 rounded-lg transition duration-300 focus:outline-none"
              >
                + Zoom In
              </button>

              <button
                type="button"
                onClick={closeSampleModal}
                className="flex-1 bg-solidBlue hover:bg-opacity-95 text-white font-semibold py-2 px-4 rounded-lg transition duration-300 focus:outline-none"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LandingPageNav;
